import axios from 'axios';
import React, { useContext } from 'react'
import { useForm } from 'react-hook-form';
import { Link, useHistory, useLocation} from 'react-router-dom';
import { toast } from 'react-toastify';
import { AllContextData } from '../App';

export default function Login() {
    const { loggedInUser, setLoggedInUser } = useContext(AllContextData);
    const history = useHistory()
    const location = useLocation();
    const { from } = location.state || { from: { pathname: "/" } };
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
      } = useForm();

    const onSubmit = (data) => {
        axios.post(
          `https://ahlehaqserver.herokuapp.com/api/auth/login`,
          data
        )
        .then(res => {
          if(res.data.message === 'success') {
              toast('Successfully Login!');
              sessionStorage.setItem('loggedInUser', JSON.stringify(res.data));
              setLoggedInUser(res.data);
              history.replace(from);
            }else if(res.data.message === 'Unauthenticated'){
                toast(res.data.message+"!!")
            }
        })
    };
    return (
        <div className="container">
        <div className="row mt-5 justify-content-center">
            <div className="col-md-4 mt-5">
                <div className="authCardStyle">
                    <h3 className="text-center">Login</h3>
                    <form action="" onSubmit={handleSubmit(onSubmit)}>
                        {/* <label htmlFor="" className="font-weight-bold mt-2">
                        Write your name
                        </label>
                        <input
                        type="text"
                        name="name"
                        placeholder="Write your name"
                        className="form-control rounded-pill"
                        {...register("name", { required: true })}
                        />
                        {errors.name && (
                        <span className=" text-muted text-center d-block">
                            This field is required
                        </span>
                        )} */}
                        <label htmlFor="" className="font-weight-bold mt-4">
                        Write your Email
                        </label>
                        <input
                        type="email"
                        name="email"
                        placeholder="Write your email address"
                        className="form-control rounded-pill"
                        {...register("email", { required: true })}

                        />
                     {errors.email && (
                        <span className=" text-light text-muted d-block">
                            This field is required
                        </span>
                        )}

                        <label htmlFor="" className="font-weight-bold mt-4">
                        Write your password
                        </label>
                        <input
                        type="password"
                        name="password"
                        placeholder="Write your password"
                        className="form-control rounded-pill"
                        {...register("password", { required: true })}
                        />
                        {errors.password && (
                        <span className=" text-light text-muted d-block">
                            This field is required
                        </span>
                        )}
                        {/* <Link to="/admin/signup">
                            <p className="text-muted text-center mb-3">Create a new account</p>
                        </Link> */}
                        <div className="text-center mt-5">
                        <button type="submit" className="btn btn-info btn-block rounded-pill ">
                            Log in
                        </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    )
}
